var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ui-badge-container",class:{ warning: _vm.warning, error: _vm.error, small: _vm.small }},[_c('i',{staticClass:"gts-icon icon-status-info"}),_c('span',[_vm._v(_vm._s(_vm.msg))])])
}
var staticRenderFns = []

export { render, staticRenderFns }